import { SessionOptions } from "~/modules/session";

const defaultSessionOptions: SessionOptions = {
    autoUpdateToken: true
};

export function getDefaultSessionOptions(): SessionOptions {
    return defaultSessionOptions;
}
